import { SpeedControl } from '@/components/shared/speed-control'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'

type Props = {
  isOpen: boolean
  onClose: () => void
  playbackRate: number
  onPlaybackRateChange: (rate: number) => void
}

const PRESET_SPEEDS = [0.75, 1.0, 1.25, 1.5, 2.0, 2.5]

export const PlaybackSpeedSheet = ({ isOpen, onClose, playbackRate, onPlaybackRateChange }: Props) => {
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="bottom">
        <SheetHeader>
          <SheetTitle>再生速度</SheetTitle>
        </SheetHeader>
        <div className="mt-4 pb-4">
          <SpeedControl
            presetSpeeds={PRESET_SPEEDS}
            min={0.5}
            max={3.0}
            step={0.05}
            playbackSpeed={playbackRate}
            onChangeSpeed={onPlaybackRateChange}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
